<template>
  <v-card outlined>
    <v-card-text class="pa-2">
      <v-row no-gutters>
        <v-col cols="12" sm="6" md="3">
          <im-statistics-interval-filter
            :from.sync="c_from"
            :until.sync="c_until"
          />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
  export default {

    components: {
      'im-statistics-interval-filter':  () => import('@/components/Statistics/Filters/StatisticsIntervalFilter')
    },

    props: {
      from: null,
      until: null
    },

    computed: {
      c_from: {
        get() { return this.from; },
        set(val) { this.$emit("update:from", val) }
      },
      c_until: {
        get() { return this.until; },
        set(val) { this.$emit("update:until", val) }
      }
    }

  }
</script>